// extracted by mini-css-extract-plugin
module.exports = {"existing":"CopyTemplateModal_existing__1NbtF","submitButton":"CopyTemplateModal_submitButton__x7_tu"};